import { render, staticRenderFns } from "./McolMenu.vue?vue&type=template&id=4844b40e"
import script from "./McolMenu.vue?vue&type=script&lang=js"
export * from "./McolMenu.vue?vue&type=script&lang=js"
import style0 from "./McolMenu.vue?vue&type=style&index=0&id=4844b40e&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports